module.exports = __webpack_public_path__ + "assets/img/comp_4-1.484d63ff.png";